// 9fbef606107a605d69c0edbcd8029e5d
import HEADER_MIDDLE_CONSTANTS from './SearchBar.constants';

export const getTrendingSearchResult = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.TRENDING_SEARCH, payload };
};

export const getSearchResult = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.START_SEARCH, payload };
};

export const getPopularSearch = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.POPULAR_SEARCH, payload };
};

export const setPopularSearch = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.SET_POPULAR_SEARCH, payload };
};

export const setSearchResult = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.SET_SEARCH, payload };
};

export const setTrendingSearchResult = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.SET_TRENDING_SEARCH, payload };
};

export const setShowMoreProductFlag = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.SET_SHOW_MORE_PRODUCT_FLAG, payload };
};

export const setTrendingSearchProducts = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.SET_TRENDING_SEARCH_PRODUCTS, payload };
};

export const fetchTrendingSearchProducts = (payload) => {
  return { type: HEADER_MIDDLE_CONSTANTS.FETCH_TRENDING_SEARCH_PRODUCTS, payload };
};
